import { html } from "lit";
var icon_expand_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M12.39 18.21a.997.997 0 011.318.083 1 1 0 010 1.414L7.422 26l4.082.001v2H4.012v-7.5h1.997v4.085l6.287-6.292zm6.894 1.087a1 1 0 011.414 0l5.292 5.286v-4.079h2v7.492h-7.5v-1.998h4.087l-5.293-5.288-.083-.094a.998.998 0 01.083-1.319zM11.508 4.004v1.998L7.417 6l6.296 6.289.083.094a1 1 0 01-1.497 1.319L6.007 7.418v4.078h-2V4.004h7.5zM27.986 4v7.5h-1.998V7.414l-5.287 5.293-.094.083a.998.998 0 01-1.319-1.497L24.574 6h-4.08V4h7.492z" />
  </svg>
`;
export {
  icon_expand_default as default
};
//# sourceMappingURL=icon-expand.js.map
